/** Invalidates responses after a newer request or an identity boundary. */
export class RequestGeneration {
  private value = 0;
  next() { return ++this.value; }
  current(ticket: number) { return ticket === this.value; }
}
